import { Filter } from 'components/molecules/filters/types';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { QueryCombinerType } from 'components/organisms/tasks/combiner';
import { FieldFilter } from 'components/organisms/tasks/filters';

export enum TimesheetReportTab {
  Project = 'project',
  User = 'user',
  Category = 'category',
  Task = 'task',
  Phase = 'phase',
}
export const overallReportTabs = [
  TimesheetReportTab.Project,
  TimesheetReportTab.User,
  TimesheetReportTab.Category,
];
export const projectWiseReportTabs = [
  TimesheetReportTab.User,
  TimesheetReportTab.Phase,
  TimesheetReportTab.Task,
  TimesheetReportTab.Category,
];
export const peopleWiseReportTabs = [
  TimesheetReportTab.Project,
  TimesheetReportTab.Category,
];
export const categoryWiseReportTabs = [
  TimesheetReportTab.Project,
  TimesheetReportTab.User,
];

export interface CategorySummary {
  label: string;
  minutes: number;
  percentage: number;
  deleted?: boolean;
}
export interface ReportFilter extends Filter {
  range: DateRange;
}
export interface TimesheetOverallReportSearchParams {
  viewId?: number;
  filter: ReportFilter;
}
export interface ReportParam {
  startDate: string;
  endDate: string;
  validFilters: FieldFilter[];
  match: QueryCombinerType;
}
